import { render, staticRenderFns } from "./Watch.vue?vue&type=template&id=cdde04f0"
import script from "./Watch.vue?vue&type=script&lang=js"
export * from "./Watch.vue?vue&type=script&lang=js"
import style0 from "./Watch.vue?vue&type=style&index=0&id=cdde04f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports